import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import LedgerProjectReport from "./ledgerProjectReport";
import { hasPermission } from "../utils/usePermissions";
import RentedItemRequirementReport from "./RentedItemRequirement";

const AdminReports = ({ permissions }) => {
  const [selectedReport, setSelectedReport] = useState("");
  const navigate = useNavigate();

  const renderReport = () => {
    switch (selectedReport) {
      case "LedgerProjectReport":
        return <LedgerProjectReport />;
      case "RentedItemRequirement":
        return <RentedItemRequirementReport />;

      default:
        return (
          <div className="text-muted mt-4">
            Please select a report
          </div>
        );
    }
  };

  const checkboxStyle = (checked) => ({
    width: "18px",
    height: "18px",
    border: "3px solid #198754",
    borderRadius: "2px",
    appearance: "none",
    cursor: "pointer",
    backgroundColor: checked ? "#198754" : "#fff",
  });

  return (
    <div className="container-fluid mt-5">
      <div className="card">
        <div className="card-body">
          <div className="row">

            {hasPermission(permissions, ["ProjectReport"]) && (
              <div className="col-md-4">
                <div className="form-check d-flex align-items-center gap-2">
                  <input
                    id="projectItemReport"
                    type="checkbox"
                    checked={selectedReport === "projectItemReport"}
                    onChange={() => setSelectedReport("projectItemReport")}
                    style={checkboxStyle(selectedReport === "projectItemReport")}
                  />
                  <label htmlFor="projectItemReport" style={{ cursor: "pointer" }}>
                    Project Item Reports
                  </label>
                </div>
              </div>
            )}

            {hasPermission(permissions, ["LedgerProjectReport"]) && (
              <div className="col-md-4">
                <div className="form-check d-flex align-items-center gap-2">
                  <input
                    id="LedgerProjectReport"
                    type="checkbox"
                    checked={selectedReport === "LedgerProjectReport"}
                    onChange={() => setSelectedReport("LedgerProjectReport")}
                    style={checkboxStyle(selectedReport === "LedgerProjectReport")}
                  />
                  <label htmlFor="LedgerProjectReport" style={{ cursor: "pointer" }}>
                    Ledger Project Report
                  </label>
                </div>
              </div>
            )}

            {hasPermission(permissions, ["RentedItemRequirement"]) && (
              <div className="col-md-4">
                <div className="form-check d-flex align-items-center gap-2">
                  <input
                    id="RentedItemRequirement"
                    type="checkbox"
                    checked={selectedReport === "RentedItemRequirement"}
                    onChange={() => setSelectedReport("RentedItemRequirement")}
                    style={checkboxStyle(selectedReport === "RentedItemRequirement")}
                  />
                  <label htmlFor="RentedItemRequirement" style={{ cursor: "pointer" }}>
                    Rented Item Requirement
                  </label>
                </div>
              </div>
            )}

          </div>

          {selectedReport === "projectItemReport" && (
            <div className="mt-4">
              <button
                className="btn btn-success"
                onClick={() => navigate("../../ProjectReport")}
              >
                Open
              </button>
            </div>
          )}
        </div>
      </div>

      {/* 🔴 THIS WAS MISSING */}
      <div className="mt-3">
        {renderReport()}
      </div>
    </div>
  );
};

export default AdminReports;
